import { render, staticRenderFns } from "./ReportTypeSelector.vue?vue&type=template&id=31be14f4"
import script from "./ReportTypeSelector.vue?vue&type=script&lang=js"
export * from "./ReportTypeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports